import { z } from 'zod';
import { ClaimNumberSchema, InitialClaimActionsSchema } from '../model/index.js';
import { BaseHeaderSchema } from './base.js';
const UpdateInitialClaimActionsSchemas = {
    params: z.object({
        claimNumber: ClaimNumberSchema,
    }),
    body: z.object({
        initialClaimActions: InitialClaimActionsSchema.array(),
    }),
    headers: BaseHeaderSchema,
    response: z.object({
        claimNumber: ClaimNumberSchema,
        initialClaimActions: InitialClaimActionsSchema.array(),
    }),
};
export const UpdateInitialClaimActionsRequestSchema = UpdateInitialClaimActionsSchemas.params
    .merge(UpdateInitialClaimActionsSchemas.body)
    .merge(UpdateInitialClaimActionsSchemas.headers);
export const UpdateInitialClaimActionsApiSchema = UpdateInitialClaimActionsSchemas;
